import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)(({ theme }) => ({
  width: "100%",
}));

export const MainListContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "end",
  justifyContent: "center",
}));

export const ExtensionListContainer = styled(Grid)(({ theme }) => ({
  padding: "10px",
}));

export const Title = styled(Typography)(({ theme }) => ({
  // fontWeight: "bold",
  color: theme.palette.text.secondary,
}));

export const List = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  alignItems: "end",
});
